import { render, staticRenderFns } from "./DlgPostsEdit.vue?vue&type=template&id=1b641c7f&scoped=true&"
import script from "./DlgPostsEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgPostsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b641c7f",
  null
  
)

export default component.exports